<template>
  <div>
    <div class="container">
      <div class="logos">
        <img src="@/assets/images/logo2.png"  alt="">
        <span>大件物流数智平台</span>
      </div>
      <div class="list mt20" @click="goToApp('appmarket://details?id=uni.UNI96F70F921111')"><img src="@/assets/images/app/huawei.png" alt=""/>  <span class="cl7b">从</span> <em>华为应用商店</em>  <span  class="cl7b">下载</span></div>
      <div class="list" @click="goToApp('mimarket://details?id=uni.UNI96F70F921111')"><img src="@/assets/images/app/xiaomi.png" alt=""/>  <span class="cl7b">从</span> <em>小米应用商店</em>  <span  class="cl7b">下载</span></div>
      <div class="list" @click="goToApp('vivomarket://details?id=uni.UNI96F70F921111')"><img src="@/assets/images/app/vivo.png" alt=""/> <span class="cl7b">从</span> <em>vivo应用商店</em>  <span  class="cl7b">下载</span></div>
      <div class="list" @click="goToApp('oppomarket://details?packagename=uni.UNI96F70F921111')"><img src="@/assets/images/app/oppo.png" alt=""/> <span class="cl7b">从</span> <em>OPPO应用商店</em>   <span  class="cl7b">下载</span></div>
      <!--        <div class="list"><img src="@/assets/images/app/yyb.svg" alt=""/>  <span class="cl7b">从</span> <em>应用宝</em>  <span  class="cl7b">下载</span></div>-->
      <div class="list"  @click="goToApp('appmarket://details?id=uni.UNI96F70F921111')"><img src="@/assets/images/app/honor.png" alt=""/>  <span class="cl7b">从</span> <em>荣耀应用商店</em>  <span  class="cl7b">下载</span></div>
      <div class="list" @click="goToApp('https://www.pgyer.com/dajian-android')"><img src="@/assets/images/app/android.png" alt=""/>  <span class="cl7b">下载APK文件</span></div>
      <div class="list" @click="goDwonload()"> <span class="cl7b" id="xiazai">{{ downloads ? '文件下载中...' : '用户手册' }}</span></div>
      <img src="@/assets/images/app/weixin.png" class="weixin" id="weixin">
    </div>
  </div>
</template>
<script>
import { getHotList, getInfo } from "@/api/news";
export default {
  name: 'index',
  data() {
    return {
      downloads: false
    }
  },
  mounted() {


    if ( this.isWeChatBrowser()) {
      console.log("✅ 当前是微信浏览器");
      document.getElementById('weixin').style.display = 'block';
    } else {
      console.log("❌ 不是微信浏览器");
      if (this.getSystem() === 'iOS') {
        this.goToApp('https://apps.apple.com/cn/app/i%E5%A4%A7%E4%BB%B6/id6751037516')
      }
    }
  },
  methods: {
    exportFile(url, fileName, callback) {
      const xhr = new XMLHttpRequest()
      const formData = new FormData()
      xhr.open('get', url) // url填写后台的接口地址，如果是post，在formData append参数

      xhr.responseType = 'blob'
      xhr.onload = function (e) {
        if (this.status === 200) {
          var blob = this.response
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName)
          } else {
            var a = document.createElement('a')
            var url = window.URL.createObjectURL(blob)
            a.href = url
            a.download = fileName
            document.body.appendChild(a)
            a.click()
            window.URL.revokeObjectURL(url)
            callback()
          }
        }
      }
      xhr.send(formData)
    },
    goDwonload () {
      this.downloads = true
      getInfo({
        "categoryCode": "HELP",
        "keyword": "用户手册",
        "limit": 5,
        "platform": "APPToB"
      }).then(res=> {
        let fileId =  res.data[0].attachmentUrls
        this.exportFile(`/apis/dj-common-api/fileserv/v2/download/${fileId}/KNNBhsnan`, '用户手册', () => {
          this.downloads = false
        })
      })
    },
    getSystem() {
      const ua = navigator.userAgent.toLowerCase()
      if (/iphone|ipad|ipod/.test(ua)) {
        return 'iOS'
      } else if (/android/.test(ua)) {
        return 'Android'
      } else {
        return 'Other'
      }
    },
    goToApp(url) {
      window.location.href = url;
    },
    isWeChatBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf('micromessenger') !== -1;
    }
  }
}
</script>


<style scoped lang="less">
::v-deep #app{
  min-width: 0 !important;
}

.container{
  width: 100%;
  height: 100%;
  padding: 40px 30px;
  background: #FFFFFF;
}
.logos{
  display: flex;
  align-items: center;
  justify-content: center;
}
.logos img{
  background: #FFFFFF;
  box-shadow: 0 0 8px rgba(0,0,0,.06),0 2px 12px rgba(0,0,0,.12);
  padding: 10px;
  width: 60px;
  border-radius: 10px;
}
.logos span{
  font-size: 23px;
  font-weight: 900;
  margin-left: 15px;
}
.mt20{
  margin-top: 40px;
}
.list{
  border-radius: 8px;
  padding: 10px;
  border:1px solid #dadada;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.list img{
  width: 24px;
  height: 24px;
  margin-right: 10px;
}
.list em{
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  margin: 0 3px;
}
.cl7b{
  color: #7B7B7B;
}
.weixin{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: none;
}
</style>